import BottomNavigation from ".";

export default function BottomNavigationExamples() {
  return <BottomNavigation />;
}
